module.exports = __webpack_public_path__ + "static/img/task-icon3 (1).95d5739.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/task/task-icon3 (1).png
// module id = x871
// module chunks = 1